<template>
  <modal-container :isModalActive="activeModal" v-on:closeModal="close">
    <div v-if="activeModal" slot="modal-content" class="fh overflow-y">
      <div class="content-layout fh">
        <div class="modal-left fh">
          <div class="learners-info">
            <div class="avatar-placeholder rb shadow">
              <b-icon
                icon="account"
                type="is-light"
                custom-size="mdi-250px"
                class="avatar"
              ></b-icon>
            </div>
            <div class="info">
              <div>
                <div
                  class="bold rb white-txt msg-btn green-alt pointer"
                  @click="navigateToMessage"
                >
                  Message
                </div>
              </div>
              <div>
                <div class="student-info-line">
                  <div class="bold info-query">Student Name</div>
                  <div class="info-query">
                    {{
                      `${activeUser.firstName} ${
                        activeUser.lastName === "n/a" ? "" : activeUser.lastName
                      }`
                    }}
                  </div>
                </div>
                <div class="student-info-line">
                  <div class="bold info-query">{{ gradeLabel() }}</div>
                  <div class="info-query">{{ grade() }}</div>
                </div>
                <div v-if="activeUser.school" class="student-info-line">
                  <div class="bold info-query">School Name</div>
                  <div class="info-query">{{ activeUser.school }}</div>
                </div>
                <div v-if="activeUser.email" class="student-info-line">
                  <div class="bold info-query">Email Address</div>
                  <div class="info-query">{{ activeUser.email }}</div>
                </div>
                <div v-if="activeUser.cellphone" class="student-info-line">
                  <div class="bold info-query">Contact Number</div>
                  <div class="info-query">
                    {{ activeUser.cellphone }}
                  </div>
                </div>
                <div
                  v-if="activeUser.engagement && activeUser.engagement.lastSeen"
                  class="student-info-line"
                >
                  <div class="bold info-query">Last Seen</div>
                  <div class="info-query">
                    {{ lastSeen }}
                  </div>
                </div>
              </div>
            </div>
            <div class="pointer bottom">
              <div
                class="bold rb green-txt msg-btn shadow download-pdf-report"
                @click="downloadLearnerReport"
              >
                Generate Full Report
                <b-icon icon="download" custom-size="default" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-right fh">
          <div class="learner-profile-right">
            <div class="profile-btns">
              <section-btn
                name="assessments"
                :btn="0"
                :active="activeSection"
                v-on:buttonClicked="updateActiveSection"
              />
              <section-btn
                name="catchup"
                :btn="1"
                :active="activeSection"
                v-on:buttonClicked="updateActiveSection"
              />
              <section-btn
                name="Improvement"
                :btn="2"
                :active="activeSection"
                v-on:buttonClicked="updateActiveSection"
              />
              <section-btn
                name="Engagement"
                :btn="3"
                :active="activeSection"
                v-on:buttonClicked="updateActiveSection"
              />
            </div>
            <div class="learner-profile-charts">
              <div class="assessment" v-if="activeSection === 0">
                <div class="left">
                  <div class="learner-results rb shadow">
                    <div style="padding: 5px 16px" class="bold">
                      Assessment Results
                    </div>
                    <div v-if="lrChart.data">
                      <bar-chart
                        style="
                          padding: 10px 0;
                          width: 90%;
                          margin: auto;
                          position: relative;
                        "
                        ref="assessment-progress"
                        chart-id="assessment-results-chart"
                        :chart-data="lrChart.data"
                        :extra-options="lrChart.extraOptions"
                      >
                      </bar-chart>
                    </div>
                  </div>
                  <div class="learner-progress">
                    <div style="padding: 5px 16px" class="bold">
                      Assessment Progress
                    </div>
                    <div class="tiny-progress">
                      <div
                        v-for="(progress, index) in progressPerThread.data"
                        :key="index"
                      >
                        <tiny-box
                          :title="progressPerThread.labels[index]"
                          :content="progress"
                          :reassessment="checkIfReassessment(index)"
                        />
                      </div>
                    </div>
                    <div style="margin-top: 8px">
                      <span class="bold" style="font-size: 16px; color: red"
                        >*
                      </span>
                      <span class="semibold"> - Reassessment Progress</span>
                    </div>
                  </div>
                </div>
                <div class="right rb shadow tester">
                  <div class="headingg bold" style="padding: 5px 16px 8px">
                    {{ progressPerThread.labels[activeResultsThread - 1] }}
                    Results By Concept
                    <span class="instructions"
                      >Click the bar chart to see concept results</span
                    >
                  </div>
                  <div class="tester1">
                    <div class="tester2 has-sticky-header">
                      <div v-if="conceptResults.length > 0">
                        <div
                          v-for="(concept, index) in conceptResults"
                          :key="index"
                        >
                          <concept-block
                            :conceptName="concept.name"
                            :conceptMastery="
                              contextualSpecificGradeAndPrefix(concept.mastery)
                            "
                            :color="concept.color"
                          />
                        </div>
                      </div>
                      <div v-else style="text-align: center; color: red">
                        User has not yet completed this Thread
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="" v-if="activeSection === 1">
                <div class="rb shadow margin-bottom">
                  <div style="padding: 5px 16px" class="bold">
                    Catchup Progress
                  </div>
                  <div v-if="lcpChart.data">
                    <bar-chart
                      style="
                        padding: 10px 0;
                        width: 90%;
                        margin: auto;
                        position: relative;
                      "
                      ref="assessment-progress"
                      chart-id="assessment-results-chart"
                      :chart-data="lcpChart.data"
                      :extra-options="lcpChart.extraOptions"
                    >
                    </bar-chart>
                  </div>
                </div>
                <div class="catchup-progress">
                  <div style="padding: 5px 16px" class="bold margin-bottom">
                    Concept Learner is working on
                  </div>
                  <div class="tiny-btn">
                    <div
                      v-for="(progress, index) in progressPerThread.data"
                      :key="index"
                    >
                      <tiny-box
                        :title="progressPerThread.labels[index]"
                        :concept="currentConcept[index]"
                        :showPercent="false"
                        :numberInput="false"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="" v-if="activeSection === 2">
                <div class="rb shadow">
                  <div style="padding: 5px 16px" class="bold">Improvements</div>
                  <div v-if="impChart.data">
                    <bar-chart
                      style="
                        padding: 10px 0;
                        width: 90%;
                        margin: auto;
                        position: relative;
                      "
                      ref="improvements"
                      chart-id="improvements-chart"
                      :chart-data="impChart.data"
                      :extra-options="impChart.extraOptions"
                    >
                    </bar-chart>
                  </div>
                </div>
                <div class="catchup-progress">
                  <div style="padding: 5px 16px" class="bold">
                    Number of Reassessments Done Per Thread
                  </div>
                  <div class="tiny-btn">
                    <div
                      v-for="(progress, index) in progressPerThread.data"
                      :key="index"
                    >
                      <tiny-box
                        :title="progressPerThread.labels[index]"
                        :content="reAssessmentsDone(index)"
                        :showPercent="false"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="" v-if="activeSection === 3">
                <div class="rb shadow">
                  <div style="padding: 5px 16px" class="bold">
                    Engagement in the last month
                  </div>
                  <div v-if="eChart.data">
                    <engagements-chart
                      :chartData="engagementChartData"
                      :options="engagementsChartOptions"
                    >
                    </engagements-chart>
                  </div>
                </div>
                <!-- <div class="catchup-progress">
                  <div style="padding: 5px 16px" class="bold">
                    Time spent on app in past week
                  </div>
                  <div class="tiny-btn">
                    <div
                      v-for="(progress, index) in progressPerThread.data"
                      :key="index"
                    >
                      <tiny-box
                        :title="progressPerThread.labels[index]"
                        :content="reAssessmentsDone(index)"
                        :showPercent="false"
                      />
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal-container>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import SectionButtonComponent from "@/modules/global/components/SectionButtonComponent.vue";
import ModalContainer from "@/modules/global/containers/ModalContainer.vue";
import TinyBoxComponent from "@/modules/global/components/TinyBoxComponent.vue";
// import catchupChartData from "@/modules/global/mixins/catchupChartData.js";
import individualUserDataMixin from "@/modules/global/mixins/individualUserDataMixin.js";
import assessmentChartDataGeneratorMixin from "@/modules/global/mixins/assessmentChartDataGeneratorMixin.js";
import engagementChartDataGeneratorMixin from "@/modules/global/mixins/engagementChartDataGeneratorMixin.js";
import localizationMixin from "@/modules/global/mixins/localizationMixin.js";
import BarChart from "@/modules/global/lib/charts/BarChart.js";
import ConceptBlock from "@/modules/global/components/LearnerProfileConceptBlockComponent.vue";
import moment from "moment";
import { createPdf } from "@/modules/global/mixins/pdfMixin.js";
//@refactor for multiple subjects
import matric from "@/modules/global/utils/thread-layouts/matric-foundation.json";
import juniorHigh from "@/modules/global/utils/thread-layouts/junior-high.json";
import seniorPrimary from "@/modules/global/utils/thread-layouts/senior-primary.json";
import juniorPrimary from "@/modules/global/utils/thread-layouts/junior-primary.json";
import adultNumeracy from "@/modules/global/utils/thread-layouts/adult-numeracy.json";
import englishJuniorHigh from "@/modules/global/utils/thread-layouts/english-junior-high.json";
import englishSeniorPrimary from "@/modules/global/utils/thread-layouts/english-senior-primary.json";
import EngagementsChart from "../../home/components/EngagementsChart.vue";

export default {
  name: "LearnerProfile",
  props: {},
  data() {
    return {
      activeSection: 0,
      baseStackedChartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: "bottom"
        },
        responsive: true
      },
      activeResultsThread: 1
    };
  },
  mixins: [
    localizationMixin,
    assessmentChartDataGeneratorMixin,
    engagementChartDataGeneratorMixin,
    individualUserDataMixin
  ],
  components: {
    "engagements-chart": EngagementsChart,
    "modal-container": ModalContainer,
    "section-btn": SectionButtonComponent,
    "bar-chart": BarChart,
    "tiny-box": TinyBoxComponent,
    "concept-block": ConceptBlock
  },
  computed: {
    ...mapState({
      activeModal: state => state.globalStore.settings.isLearnerModalActive,
      active: state => state.globalStore.activeFilterParams,
      activeUser: state => state.globalStore.activeUser,
      activeButton: state => state.globalStore.settings.learnerButtonActive,
      threadId: state => state.globalStore.activeFilterParams.threadId,
      projectName: state => state.globalStore.activeFilterParams.projectName,
      isInternal: state => state.globalStore.settings.isInternal,
      reflectiveData: state => state.globalStore.reflectiveData,
      currentSubject: state =>
        state.globalStore.activeFilterParams.currentSubject
    }),
    ...mapGetters({
      userData: "globalStore/getFilteredList",
      hasFetchedEngagements: "globalStore/hasFetchedEngagements",
      rawEngagementsData: "newEngagementsStore/getRawEngagementsData"
    }),
    assessmentType() {
      return this.activeUser.assessmentStates[0].type;
    },
    concepts() {
      if (this.activeAssessmentType === "MATHS_SENIOR_PRIMARY") {
        return seniorPrimary;
      } else if (this.activeAssessmentType === "MATHS_JUNIOR_PRIMARY") {
        return juniorPrimary;
      } else if (this.activeAssessmentType === "MATHS_MATRIC_FOUNDATIONS") {
        return matric;
      } else if (this.activeAssessmentType === "MATHS_ADULT_NUMERACY") {
        return adultNumeracy;
      } else if (this.activeAssessmentType === "ENGLISH_JUNIOR_HIGH") {
        return englishJuniorHigh;
      } else if (this.activeAssessmentType === "ENGLISH_SENIOR_PRIMARY") {
        return englishSeniorPrimary;
      } else {
        return juniorHigh;
      }
    },
    conceptResults() {
      let results = [];
      let activeThreadFeedback = this.activeUser.assessmentStates[0].feedback.find(
        thread => thread.threadId == this.activeResultsThread
      );
      // console.log(this.activeResultsThread, this.concepts);
      let activeThreadConcepts = this.concepts[this.activeResultsThread];
      if (activeThreadFeedback) {
        activeThreadFeedback.conceptMastery.forEach((concept, index) => {
          let correctConcept = activeThreadConcepts.find(
            concepts => concepts.concept == index + 1
          );
          if (concept === 3) {
            results.push({
              name: correctConcept.name,
              mastery: this.conceptMasteryToGrade(concept),
              color: "green"
            });
          } else if (concept === 2) {
            results.push({
              name: correctConcept.name,
              mastery: this.conceptMasteryToGrade(concept),
              color: "yellow"
            });
          } else {
            results.push({
              name: correctConcept.name,
              mastery: this.conceptMasteryToGrade(concept),
              color: "red"
            });
          }
          // results.push({ name: correctConcept.name, mastery: concept });
        });
      }
      return results;
    },
    currentConcept() {
      if (this.activeUser.catchupStates && this.activeUser.catchupStates[0]) {
        let concepts = this.activeUser.catchupStates[0].threads.map(thread => {
          if (!this.concepts[thread.threadId]) {
            return "Not Found";
          }
          let foundconcept = this.concepts[thread.threadId].findIndex(
            concept => concept.concept == thread.stage.concept
          );
          if (foundconcept !== -1) {
            return this.concepts[thread.threadId][foundconcept].name;
          } else {
            if (thread.stage.concept == 0) {
              return "Not Started";
            }
            return "Completed";
          }
        });
        return concepts;
      }
      return [];
    },
    activeAssessmentType() {
      return this.activeUser.assessmentStates[0].type;
    },
    daysOfTheWeek() {
      let currentDay = moment().day();
      let weekdaysArray = moment.weekdaysShort();
      let splicedDays = weekdaysArray.splice(currentDay + 1);
      return [...splicedDays, ...weekdaysArray];
    },
    lastSeen() {
      return moment(this.activeUser.engagement.lastSeen).fromNow();
    },
    engagementsChartOptions() {
      return {
        maintainAspectRatio: false,
        legend: { display: true },
        responsive: true,
        scales: {
          yAxes: [
            {
              stacked: false,
              gridLines: {
                drawBorder: true,
                color: "rgba(29,140,248,0.0)"
              },
              scaleLabel: {
                display: true,
                labelString: "Time Spent (minutes)",
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: true,
                beginAtZero: true,
                min: 0,
                fontColor: "#9a9a9a",
                callback: function(value) {
                  if (Number.isInteger(value)) {
                    return `${value}`;
                  }
                }
              }
            }
          ],
          xAxes: [
            {
              stacked: false,
              gridLines: {
                drawBorder: true,
                color: "rgba(225,78,202,0.1)"
              },
              scaleLabel: {
                display: true,
                labelString: "Day",
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: true,
                fontColor: "#9a9a9a"
              }
            }
          ]
        }
      };
    },
    engagementChartData() {
      return {
        labels: this.engagementsChartXaxis,
        datasets: [
          {
            label: "Total App time",
            backgroundColor: "#AA7DFB",
            data: this.engagementsChartYaxisAppTime
          },
          {
            label: "Total Learning time",
            backgroundColor: "#30866e",
            data: this.engagementsChartYaxisLearningTime
          }
        ]
      };
    },
    engagementsChartXaxis() {
      const engEndDate = moment();
      const engStartDate = moment().subtract(30, "days");
      return this.getEngagementsDates(engStartDate, engEndDate).map(date =>
        moment(date).format("MMM Do YY")
      );
    },
    engagementsChartYaxisAppTime() {
      const engEndDate = moment();
      const engStartDate = moment().subtract(30, "days");

      return this.getEngagementsDates(engStartDate, engEndDate).map(date => {
        // get daily duration
        let activeUserData = this.rawEngagementsData.find(
          data => data.uid == this.activeUser._id
        );

        if (activeUserData) {
          let dayObj = activeUserData.activeDates.find(
            activeDate => activeDate.eventDate.value == date
          );
          if (dayObj) return Math.round(dayObj.dailyAppTime / 60);
          else return 0;
        } else return 0;
      });
    },
    engagementsChartYaxisLearningTime() {
      const engEndDate = moment();
      const engStartDate = moment().subtract(30, "days");

      return this.getEngagementsDates(engStartDate, engEndDate).map(date => {
        // get daily duration
        let activeUserData = this.rawEngagementsData.find(
          data => data.uid == this.activeUser._id
        );

        if (activeUserData) {
          let dayObj = activeUserData.activeDates.find(
            activeDate => activeDate.eventDate.value == date
          );
          if (dayObj) return Math.round(dayObj.dailyDuration / 60);
          else return 0;
        } else return 0;
      });
    }
  },
  mounted() {
    this.activeSection = this.activeButton;

    // console.log("subject: ", this.currentSubject);

    // console.log("y-axis: ", this.engagementsChartYaxis);
  },
  methods: {
    ...mapMutations({
      isModalActive: "globalStore/updateIsLearnerModalActive",
      updateActiveUser: "globalStore/updateActiveUser"
    }),
    gradeLabel() {
      return this.contextualSpecificGradeLabel(this.activeUser.grade);
    },
    grade() {
      return this.contextualGrade(this.activeUser.grade);
    },
    async isInternalUpdateActiveSection(payload) {
      if (this.isInternal) return this.updateActiveSection(payload);
    },
    updateActiveSection(payload) {
      if (payload == 2)
        this.stackedImprovementBarGraph(this.improvementsPerThread);
      this.activeSection = payload;
    },
    navigateToMessage() {
      this.isModalActive(false);
    },
    conceptMasteryToGrade(mastery) {
      switch (this.assessmentType) {
        case "MATHS_JUNIOR_PRIMARY":
          if (mastery == 0) {
            return 0;
          } else if (mastery == 1) {
            return 1;
          } else if (mastery == 2) {
            return 2;
          } else {
            return 3;
          }
        case "MATHS_SENIOR_PRIMARY":
        case "ENGLISH_SENIOR_PRIMARY":
          if (mastery == 0) {
            return 0;
          } else if (mastery == 1) {
            return 1;
          } else if (mastery == 2) {
            return 3;
          } else {
            return 6;
          }
        case "MATHS_JUNIOR_HIGH":
        case "MATHS_MATRIC_FOUNDATIONS":
        case "ENGLISH_JUNIOR_HIGH":
        default:
          if (mastery == 0) {
            return 0;
          } else if (mastery == 1) {
            return 3;
          } else if (mastery == 2) {
            return 6;
          } else {
            return 9;
          }
      }
    },
    reAssessmentsDone(threadId) {
      if (
        this.activeUser.improvement &&
        this.activeUser.improvement[this.currentSubject][threadId + 1]
      ) {
        return (
          this.activeUser.improvement[this.currentSubject][threadId + 1]
            .length - 1
        );
      }
      return 0;
    },
    close() {
      // this.updateActiveUser(null);
      this.isModalActive(false);
    },
    checkIfReassessment(thread) {
      // console.log(this.learnerCatchupJourney);
      // console.log('thread', thread);
      if (
        this.activeUser.assessmentStates[0].threads[thread] &&
        this.activeUser.assessmentStates[0].threads[thread].reassess
      ) {
        return true;
      }
      return false;
    },
    threadClicked(thread) {
      this.activeResultsThread = thread + 1;
    },
    stackedBarGraph(params) {
      let data = {
        labels: params.labels,
        datasets: [
          {
            label: "Mastered Concepts",
            data: params.mastered,
            backgroundColor: () => {
              return this.green;
            }
          },
          {
            label: "Concepts already covered",
            data: params.done,
            backgroundColor: () => {
              return this.yellow;
            }
          },
          {
            label: "Concepts left to do",
            data: params.togo,
            backgroundColor: () => {
              return this.red;
            }
          }
        ]
      };
      let extraOptions = {
        ...this.baseStackedChartOptions,
        scales: {
          yAxes: [
            {
              stacked: true,
              gridLines: {
                drawBorder: true,
                color: "rgba(29,140,248,0.0)"
              },
              scaleLabel: {
                display: true,
                labelString: "Concepts",
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: true,
                beginAtZero: true,
                fontColor: "#9a9a9a",
                callback: function(value) {
                  if (Number.isInteger(value)) {
                    return `${value}`;
                  }
                }
              }
            }
          ],

          xAxes: [
            {
              stacked: true,
              gridLines: {
                drawBorder: true,
                color: "rgba(225,78,202,0.1)"
              },
              scaleLabel: {
                display: true,
                labelString: "Journeys",
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: true,
                fontColor: "#9a9a9a"
              }
            }
          ]
        }
      };
      this.lcpChart.data = { ...data };
      this.lcpChart.extraOptions = { ...extraOptions };
    },
    stackedImprovementBarGraph(params) {
      let data = {
        labels: params.labels,
        datasets: [
          {
            label: "Initial Results",
            data: params.initial,
            backgroundColor: () => {
              return this.yellow;
            }
          }
        ]
      };
      params.reassess.forEach((entry, entryIndex) => {
        for (let index in entry) {
          let actualIndex = parseInt(index) + 1;
          if (!data.datasets[actualIndex]) {
            data.datasets.push({
              label: `Reassessment ${actualIndex} gain`,
              data: [],
              backgroundColor: () => {
                return this[`green${actualIndex}`];
              }
            });
          }
          data.datasets[actualIndex].data[entryIndex] = entry[index]
            ? entry[index]
            : 0;
        }
      });

      let extraOptions = {
        ...this.baseStackedChartOptions,
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              gridLines: {
                drawBorder: true,
                color: "rgba(29,140,248,0.0)"
              },
              scaleLabel: {
                display: true,
                labelString: `${this.contextualGradeLabel()} Mastered`,
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: true,
                beginAtZero: true,
                fontColor: "#9a9a9a",
                callback: function(value) {
                  if (Number.isInteger(value)) {
                    return `${value}`;
                  }
                }
              }
            }
          ],

          xAxes: [
            {
              stacked: true,
              gridLines: {
                drawBorder: true,
                color: "rgba(225,78,202,0.1)"
              },
              scaleLabel: {
                display: true,
                labelString: "Journeys",
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: true,
                fontColor: "#9a9a9a"
              }
            }
          ]
        }
        // tooltips: {
        //   callbacks: {
        //     title: (tooltipItem, data) => {
        //       return data["labels"][tooltipItem[0]["index"]];
        //     },
        //     label: (tooltipItem, data) => {
        //       let percentSign = "";
        //       return (
        //         "Mastered at grade: " +
        //         Math.floor(data["datasets"][0]["data"][tooltipItem.index]) +
        //         percentSign
        //       );
        //     }
        //   }
        // }
      };
      this.impChart.data = { ...data };
      this.impChart.extraOptions = { ...extraOptions };
    },
    createLineChart(params) {
      let data = {
        datasets: [
          {
            backgroundColor: "#90BF3E",
            borderColor: "#FFD543",
            lineTension: 0.1,
            fill: false,
            pointHoverRadius: 4,
            data: params.data
          }
        ],
        labels: params.labels
      };
      let extraOptions = {
        ...this.baseChartOptions,
        scales: {
          yAxes: [
            {
              stacked: false,
              gridLines: {
                drawBorder: true,
                color: "rgba(29,140,248,0.0)"
              },
              scaleLabel: {
                display: true,
                labelString: params.yAxis,
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: true,
                beginAtZero: true,
                min: 0,
                fontColor: "#9a9a9a",
                callback: function(value) {
                  if (Number.isInteger(value)) {
                    return `${value}`;
                  }
                }
              }
            }
          ],

          xAxes: [
            {
              stacked: false,
              gridLines: {
                drawBorder: true,
                color: "rgba(225,78,202,0.1)"
              },
              scaleLabel: {
                display: true,
                labelString: params.xAxis,
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: true,
                fontColor: "#9a9a9a"
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            title: (tooltipItem, data) => {
              return "Day: " + data["labels"][tooltipItem[0]["index"]];
            },
            label: (tooltipItem, data) => {
              let tooltext = "Total time spent on app: ";
              return (
                tooltext +
                Math.floor(data["datasets"][0]["data"][tooltipItem.index]) +
                " minutes"
              );
            }
            // afterLabel: tooltipItem => {
            //   return userPayload[tooltipItem.index].grade
            //     ? "Actual grade: " + userPayload[tooltipItem.index].grade
            //     : "This is a parent User";
            // }
          }
        },
        hover: {
          onHover: function(e) {
            var point = this.getElementAtEvent(e);
            if (point.length) e.target.style.cursor = "pointer";
            else e.target.style.cursor = "default";
          }
        },
        onClick: (event, item) => {
          if (item.length > 0) {
            let index = item[0]._index;
          }
        }
      };
      this.eChart.data = { ...data };
      this.eChart.extraOptions = { ...extraOptions };
    },
    downloadLearnerReport() {
      // console.log(this.currentSubject);
      createPdf(this.activeUser, this.currentSubject);
    },
    getEngagementsDates(startDate, endDate) {
      const dates = [];
      let currentDate = startDate;
      const addDays = function(days) {
        const date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      while (currentDate <= endDate) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
      }
      return dates.map(date =>
        moment(date)
          .utc()
          .format("YYYY-MM-DD")
      );
    }
  },
  watch: {
    activeModal: {
      handler: function() {
        if (this.activeModal) {
          this.activeSection = this.activeButton;
          this.createBarChart({
            data: this.resultsPerThread.data,
            labels: this.resultsPerThread.labels,
            xAxis: "Journeys",
            yAxis: "Assessment Results",
            percentSign: false,
            chartType: 3,
            ticks: true
          });
          this.createBarChart({
            data: this.progressPerThread.data,
            labels: this.progressPerThread.labels,
            xAxis: "Journeys",
            yAxis: "Assessment Progress",
            percentSign: false,
            chartType: 4
          });
          this.stackedBarGraph(this.learnerCatchupJourney);
          this.stackedImprovementBarGraph(this.improvementsPerThread);
          this.IndividualLearnerEngagement(this.activeUser._id);
        } else {
          this.activeSection = 0;
          this.activeResultsThread = 1;
        }
      }
    }
  }
};
</script>
